import { requestTakeTeacherAttendance } from "services/events/attendance";
import useMainContext from "utils/context/useMainContext";

const useTakeTeacherAttendance = ({
	loadingRequest,
	eventData,
	fillTeacherAttendanceData,
}) => {
	const mainContext = useMainContext();
	const takeTeacherAttendance = async (isCheckIn = false) => {
		loadingRequest.show("Tomando asistencia...");
		const success = await requestTakeTeacherAttendance({
			dateEventId: eventData.dateEventId,
			isCheckIn: isCheckIn,
		});
		if (!success) {
			mainContext.setShowDialogUnexpectedError(true);
			return;
		}
		await fillTeacherAttendanceData();
		loadingRequest.hide();
	};
	return takeTeacherAttendance;
};

export default useTakeTeacherAttendance;
